import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import experince from "../assets/img/experience.svg";
import exp2 from "../assets/img/exp2.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const ExperienceCard = () => {
  // State and variables for Wipro section
  const [wiproLoopNum, setWiproLoopNum] = useState(0);
  const [wiproIsDeleting, setWiproIsDeleting] = useState(false);
  const [wiproText, setWiproText] = useState('');
  const [wiproDelta, setWiproDelta] = useState(300 - Math.random() * 100);

  // State and variables for Chegg section
  const [cheggLoopNum, setCheggLoopNum] = useState(0);
  const [cheggIsDeleting, setCheggIsDeleting] = useState(false);
  const [cheggText, setCheggText] = useState('');
  const [cheggDelta, setCheggDelta] = useState(300 - Math.random() * 100);

  const toRotateWipro = ["TalentNext Training"];
  const toRotateChegg = ["Student Matter Expert"];
  const period = 2000;

  function handleClick() {
    window.open("https://drive.google.com/file/d/12g2vCeGMeZ0jFwRu5GNnkWmxD0vUHP4s/view?usp=sharing");
  }
  function handleClick1() {
    window.open("https://cert.diceid.com/csr/cid/g4ZA7a");
  }

  useEffect(() => {
    let wiproTicker = setInterval(() => {
      tickWipro();
    }, wiproDelta);

    let cheggTicker = setInterval(() => {
      tickChegg();
    }, cheggDelta);

    return () => {
      clearInterval(wiproTicker);
      clearInterval(cheggTicker);
    };
  }, [wiproText, cheggText]);

  const tickWipro = () => {
    let i = wiproLoopNum % toRotateWipro.length;
    let fullText = toRotateWipro[i];
    let updatedText = wiproIsDeleting ? fullText.substring(0, wiproText.length - 1) : fullText.substring(0, wiproText.length + 1);

    setWiproText(updatedText);

    if (wiproIsDeleting) {
      setWiproDelta((prevDelta) => prevDelta / 2);
    }

    if (!wiproIsDeleting && updatedText === fullText) {
      setWiproIsDeleting(true);
      setWiproDelta(period);
    } else if (wiproIsDeleting && updatedText === "") {
      setWiproIsDeleting(false);
      setWiproLoopNum(wiproLoopNum + 1);
      setWiproDelta(500);
    }
  };

  const tickChegg = () => {
    let i = cheggLoopNum % toRotateChegg.length;
    let fullText = toRotateChegg[i];
    let updatedText = cheggIsDeleting ? fullText.substring(0, cheggText.length - 1) : fullText.substring(0, cheggText.length + 1);

    setCheggText(updatedText);

    if (cheggIsDeleting) {
      setCheggDelta((prevDelta) => prevDelta / 2);
    }

    if (!cheggIsDeleting && updatedText === fullText) {
      setCheggIsDeleting(true);
      setCheggDelta(period);
    } else if (cheggIsDeleting && updatedText === "") {
      setCheggIsDeleting(false);
      setCheggLoopNum(cheggLoopNum + 1);
      setCheggDelta(500);
    }
  };

  return (
    <section className="exp" id="exp">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={exp2} alt="Header Img" />
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline">EXPERIENCE-1</span>
                  <h1>{`WIPRO`} <br /><span className="txt-rotate" dataPeriod="1000" data-rotate='[ "TalentNext Training" ]'><span className="wrap">{wiproText}</span></span></h1>
                  <p>
                    ● Engaged in Wipro TalentNext training program, honing expertise in Java J2EE/Full Stack development.<br />
                    ● Develop a strong foundation in logic building, and technologies like Hibernate, Spring, and Springboot.<br />
                    ● Applied acquired knowledge effectively, demonstrating the ability to create robust software solutions.
                  </p>
                  <button onClick={handleClick1}>Work Certificate<ArrowRightCircle size={65} /></button>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
        <br></br>
        <br></br>

        <Row className="aligh-items-center">
          
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <span className="tagline">EXPERIENCE-2</span>
                  <h1>{`CHEGG INC.`} <br /><span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Student Matter Expert" ]'><span className="wrap">{cheggText}</span></span></h1>
                  <p>
                    ● Solved over 100+ complex Computer Science-related questions with a success rate of 90% .<br />
                    ● Developed problem-solving skills through extensive research and analysis.<br />
                    ● Provided exceptional customer service through clear and concise communication.
                  </p>
                  <button onClick={handleClick}>Work Certificate<ArrowRightCircle size={65} /></button>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={experince} alt="Header Img" />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
